class d extends HTMLElement {
  constructor() {
    super(), this.onChangeHandler = this.onChangeHandler.bind(this), this.onSubmitHandler = this.onSubmitHandler.bind(this), this.onResetHandler = this.onResetHandler.bind(this);
  }
  connectedCallback() {
    this.facetForm = this.querySelector("form"), this.collectionSection = document.getElementById("collection"), !(!this.facetForm || !this.collectionSection) && (this.facetForm.addEventListener("change", this.onChangeHandler), this.facetForm.addEventListener("submit", this.onSubmitHandler), this.facetForm.addEventListener("reset", this.onResetHandler));
  }
  setResultsScrollPosition() {
    var e;
    const t = ((e = this.collectionSection) == null ? void 0 : e.getBoundingClientRect().top) + window.scrollY;
    if (t && window.scrollY > t) {
      const s = t;
      window.scrollTo(0, s);
    }
  }
  updateURLHash(t) {
    const e = `${window.location.pathname}?${t}`;
    window.history.replaceState(this.paramsObject, "", e);
  }
  get formData() {
    const t = new FormData(this.facetForm), e = new FormData();
    return t.forEach((s, a) => {
      !s || s === "" || a.includes("_pseudo") || a === "sort_by" && e.has("sort_by") || e.append(a, s);
    }), e;
  }
  get params() {
    return new URLSearchParams(this.formData);
  }
  get paramsObject() {
    return Object.fromEntries(this.params);
  }
  onChangeHandler(t) {
    t.preventDefault();
    const e = t.target;
    if (e.hasAttribute("data-group")) {
      const s = e.getAttribute("data-group");
      this.facetForm.querySelectorAll(
        `input[type="checkbox"][data-group="${s}"]`
      ).forEach((r) => {
        r !== e && (r.checked = e.checked);
      });
    }
    this.onSubmit(!1, !1);
  }
  onResetHandler(t) {
    t.preventDefault(), this.onSubmit(!0, !1);
  }
  onSubmit(t = !1, e = !1) {
    if (e) {
      this.dispatchEvent(
        new CustomEvent("modal-dialog::close-all", { bubbles: !0 })
      );
      return;
    }
    this.collectionSection.dataset.loading = "true";
    const s = this.params.has("q") ? `q=${this.params.get("q")}&type=${this.params.get("type")}` : "", a = t ? s : `${this.params.toString()}`, r = `${window.location.pathname}?${a}${a.length == 0 ? "" : "&"}section_id=${this.collectionSection.dataset.sectionId}`;
    fetch(r, {
      method: "GET"
    }).then((n) => n.text()).then((n) => {
      const o = new DOMParser().parseFromString(n, "text/html");
      o.querySelectorAll("[data-swap]").forEach((c) => {
        const l = document.querySelector(
          `[data-swap="${c.dataset.swap}"]`
        );
        l && (l.innerHTML = c.innerHTML);
      });
      const i = o.querySelector("[data-products]");
      i && (this.collectionSection.dataset.products = i.getAttribute("data-products") || "", this.dispatchEvent(
        new CustomEvent("facet-filters::update", {
          bubbles: !0,
          detail: {
            productsCount: this.collectionSection.dataset.products
          }
        })
      ));
    }).then(() => {
      this.collectionSection.dataset.loading = "false", this.updateURLHash(a), this.setResultsScrollPosition();
    }).catch((n) => {
      console.error(n);
    });
  }
  onSubmitHandler(t) {
    t.preventDefault(), this.onSubmit(!1, !0);
  }
}
window.customElements.define("facet-filters-form", d);
class h extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const t = this.querySelector("[data-price-min]"), e = this.querySelector("[data-price-max]");
    !t || !e || this.querySelectorAll("button").forEach((s) => {
      s.addEventListener("click", () => {
        if (s.hasAttribute("data-active"))
          t.value = "", e.value = "", t.dispatchEvent(new Event("change", { bubbles: !0 }));
        else {
          const r = Number(
            s.getAttribute("data-set-price-max") || this.getAttribute("data-max") || 0
          ).toFixed(2), n = Number(
            s.getAttribute("data-set-price-min") || 0
          ).toFixed(2);
          t.value = n, e.value = r, e.dispatchEvent(new CustomEvent("change", { bubbles: !0 }));
        }
      });
    });
  }
}
window.customElements.define("price-facet", h);
export {
  d as FacetFiltersForm,
  h as PriceFacet
};
